export default __webpack_public_path__ + "static/media/elf.e0447215.svg";